import type {
  GetWeightingFunctionFactoryArgs,
  WeightingFunctionFactoriesPool,
  WeightingFunctionFactoriesPoolKeyMap,
} from "../weighting-function";
import { BaseResampleFilter } from "./BaseResampleFilter";
import type { ResampleFilterFactory } from "./ResampleFilterFactory";

/**
 * BaseResampleFilter factory class.
 */
export class BaseResampleFilterFactory implements ResampleFilterFactory {
  /**
   * BaseResampleFilterFactory constructor.
   *
   * @param weightingFunctionFactoriesPool
   */
  constructor(
    private readonly weightingFunctionFactoriesPool: WeightingFunctionFactoriesPool
  ) {}

  /**
   * @inheritDoc
   */
  create<
    F extends keyof WeightingFunctionFactoriesPoolKeyMap | string,
    W extends keyof WeightingFunctionFactoriesPoolKeyMap | string
  >(
    filterFunctionName: F,
    filterFunctionFactoryArgs: GetWeightingFunctionFactoryArgs<F>,
    windowFunctionFactoryName: W,
    windowFunctionFactoryArgs: GetWeightingFunctionFactoryArgs<W>,
    support: number,
    scale: number,
    blur = 1,
    windowSupport?: number
  ): BaseResampleFilter {
    const filterFunctionFactory =
      this.weightingFunctionFactoriesPool.get(filterFunctionName);
    const filterFunction = filterFunctionFactory.create(
      ...filterFunctionFactoryArgs
    );
    const windowFunctionFactory = this.weightingFunctionFactoriesPool.get(
      windowFunctionFactoryName
    );
    const windowFunction = windowFunctionFactory.create(
      ...windowFunctionFactoryArgs
    );
    return new BaseResampleFilter(
      filterFunction,
      windowFunction,
      support,
      scale,
      blur,
      windowSupport
    );
  }
}
